import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideAccountsStore } from '@surface-elements/accounts/data-access';
import { provideAdminStore } from '@surface-elements/admin/data-access';
import { provideJobsStore } from '@surface-elements/jobs/data-access';
import { provideContactsStore } from '@surface-elements/contacts/data-access';
import { provideOrdersStore } from '@surface-elements/orders/data-access';
import { provideSettingsStore } from '@surface-elements/settings/data-access';
import { provideReportsStore } from '@surface-elements/reports/data-access';
import { provideAuthStore } from './auth-store';
import { provideFeatureFlagStore } from './feature-flag-store';

// Aggregated standalone providers for every eagerly-registered NgRx feature
// slice (SEOMS-437, replaces the former RootStoreModule NgModule). Wired once
// at the app root in apps/oms/src/main.ts, alongside provideStore/provideEffects.
// Slices stay eager exactly as they were under RootStoreModule; per-route lazy
// registration is deferred to the route-config conversion leaves (SEOMS-429–435).
export function provideRootStores(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAccountsStore(),
    provideAdminStore(),
    provideJobsStore(),
    provideContactsStore(),
    provideAuthStore(),
    provideFeatureFlagStore(),
    provideOrdersStore(),
    provideSettingsStore(),
    provideReportsStore(),
  ]);
}
